import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from '@components/Layout/Layout'
import { PageLoader } from '@components/UI'

const Home = lazy(() => import('@pages/Home/Home'))
const About = lazy(() => import('@pages/About/About'))
const Solutions = lazy(() => import('@pages/Solutions/Solutions'))
const Apps = lazy(() => import('@pages/Apps/Apps'))
const Contact = lazy(() => import('@pages/Contact/Contact'))
const Privacy = lazy(() => import('@pages/Privacy/Privacy'))
const Terms = lazy(() => import('@pages/Terms/Terms'))
const NotFound = lazy(() => import('@pages/NotFound/NotFound'))

function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="sobre" element={<About />} />
          <Route path="solucoes" element={<Solutions />} />
          <Route path="apps" element={<Apps />} />
          <Route path="contato" element={<Contact />} />
          <Route path="privacidade" element={<Privacy />} />
          <Route path="termos" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  )
}

export default App
